module.exports = __webpack_public_path__ + "02_hige_black.97d29803.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer3/02_hige_black.png
// module id = 2ayP
// module chunks = 0